import { EmployeeProps } from "@/interfaces/employee_type"

// Because the Create Form uses a formProp, this function will never trigger!!!
export function DefaultProps({user}: {user: EmployeeProps}) {
    return {
        bid_name: "",
        start_date: new Date().toISOString().split('T')[0],
        status: {
            value: "Active",
            label: "Active",
        },
        category: {
            value: "Shell",
            label: "Shell",
        },
        template: {
            value: "Default",
            label: "Default",
        },
        folder_location: "",
        manager: {
            value: user.email,
            label: user.name,
        }
    }
}